const request = async (url, options = {}) => {
  const token = localStorage.getItem("token");

  const res = await fetch(`${url}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(token && { Authorization: `Bearer ${token}` }),
      ...(options.headers || {}),
    },
  });

  const text = await res.text();

  let data;
  try {
    data = JSON.parse(text);
  } catch (err) {
    throw new Error("Server error (not JSON)");
  }

  if (!res.ok) {
    throw new Error(data.message || "Request failed");
  }

  return data;
};

export default request;
